import { ExternalEvent } from '../AppContext'
import ElectronIPC from './ElectronIPC'
import { ExternalEventEmitter } from '../ExternalEventEmitter'
import { env } from './EnvironmentVariables'
import { useNonIdempotentEffect } from '@/hooks/useNonIdempotentEffect'

export default function useExternalEventLoaderService() {
    useNonIdempotentEffect(() => {
        const handler = (_ev: any, data: ExternalEvent) => {
            console.log(`ExternalEventListener: eventName="${data.eventName}" value=` + JSON.stringify(data.value))
            ExternalEventEmitter.set(data)
        }

        testExternalEventSpamming()

        ElectronIPC.registerExternalEventListener(handler)

        return () => {
            ElectronIPC.removeExternalEventListener(handler)
        }
    }, [])

    return
}

function testExternalEventSpamming() {
    setTimeout(() => {
        if (env.TEST_EXTERNAL_EVENT_SPAMMING) {
            setInterval(() => {
                ExternalEventEmitter.set({
                    eventName: '__test',
                    value: { test: '__test_value' },
                })
            }, 100)
        }
    }, 2000)
}
